/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientActionLogControllerDelete } from '../fn/client-action-log/client-action-log-controller-delete';
import { ClientActionLogControllerDelete$Params } from '../fn/client-action-log/client-action-log-controller-delete';
import { clientActionLogControllerFindAll } from '../fn/client-action-log/client-action-log-controller-find-all';
import { ClientActionLogControllerFindAll$Params } from '../fn/client-action-log/client-action-log-controller-find-all';
import { clientActionLogControllerFindById } from '../fn/client-action-log/client-action-log-controller-find-by-id';
import { ClientActionLogControllerFindById$Params } from '../fn/client-action-log/client-action-log-controller-find-by-id';
import { clientActionLogControllerSearchCursor } from '../fn/client-action-log/client-action-log-controller-search-cursor';
import { ClientActionLogControllerSearchCursor$Params } from '../fn/client-action-log/client-action-log-controller-search-cursor';
import { clientActionLogControllerSearchOffset } from '../fn/client-action-log/client-action-log-controller-search-offset';
import { ClientActionLogControllerSearchOffset$Params } from '../fn/client-action-log/client-action-log-controller-search-offset';
import { clientActionLogControllerUpdate } from '../fn/client-action-log/client-action-log-controller-update';
import { ClientActionLogControllerUpdate$Params } from '../fn/client-action-log/client-action-log-controller-update';
import { ClientActionLogDto } from '../models/client-action-log-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientActionLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientActionLogControllerFindAll()` */
  static readonly ClientActionLogControllerFindAllPath = '/api/clientActionLog';

  /**
   * 고객사 로그 전체 조회.
   *
   * 고객사 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerFindAll$Response(params?: ClientActionLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientActionLogDto>>> {
    return clientActionLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 전체 조회.
   *
   * 고객사 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerFindAll(params?: ClientActionLogControllerFindAll$Params, context?: HttpContext): Observable<Array<ClientActionLogDto>> {
    return this.clientActionLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientActionLogDto>>): Array<ClientActionLogDto> => r.body)
    );
  }

  /** Path part for operation `clientActionLogControllerSearchOffset()` */
  static readonly ClientActionLogControllerSearchOffsetPath = '/api/clientActionLog/search/offset';

  /**
   * 고객사 로그 오프셋 기반 조회.
   *
   * 고객사 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerSearchOffset$Response(params: ClientActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientActionLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 오프셋 기반 조회.
   *
   * 고객사 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerSearchOffset(params: ClientActionLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientActionLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientActionLogControllerSearchCursor()` */
  static readonly ClientActionLogControllerSearchCursorPath = '/api/clientActionLog/search/cursor';

  /**
   * 고객사 로그 커서 기반 조회.
   *
   * 고객사 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerSearchCursor$Response(params: ClientActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return clientActionLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 커서 기반 조회.
   *
   * 고객사 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerSearchCursor(params: ClientActionLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.clientActionLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientActionLogControllerFindById()` */
  static readonly ClientActionLogControllerFindByIdPath = '/api/clientActionLog/{id}';

  /**
   * 고객사 로그 ID 기반 조회.
   *
   * 고객사 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerFindById$Response(params: ClientActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientActionLogDto>> {
    return clientActionLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 ID 기반 조회.
   *
   * 고객사 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerFindById(params: ClientActionLogControllerFindById$Params, context?: HttpContext): Observable<ClientActionLogDto> {
    return this.clientActionLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientActionLogDto>): ClientActionLogDto => r.body)
    );
  }

  /** Path part for operation `clientActionLogControllerDelete()` */
  static readonly ClientActionLogControllerDeletePath = '/api/clientActionLog/{id}';

  /**
   * 고객사 로그 삭제.
   *
   * 고객사 로그을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerDelete$Response(params: ClientActionLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientActionLogDto>> {
    return clientActionLogControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 삭제.
   *
   * 고객사 로그을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientActionLogControllerDelete(params: ClientActionLogControllerDelete$Params, context?: HttpContext): Observable<ClientActionLogDto> {
    return this.clientActionLogControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientActionLogDto>): ClientActionLogDto => r.body)
    );
  }

  /** Path part for operation `clientActionLogControllerUpdate()` */
  static readonly ClientActionLogControllerUpdatePath = '/api/clientActionLog/{id}';

  /**
   * 고객사 로그 수정.
   *
   * 고객사 로그을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientActionLogControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientActionLogControllerUpdate$Response(params: ClientActionLogControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientActionLogDto>> {
    return clientActionLogControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 로그 수정.
   *
   * 고객사 로그을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientActionLogControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientActionLogControllerUpdate(params: ClientActionLogControllerUpdate$Params, context?: HttpContext): Observable<ClientActionLogDto> {
    return this.clientActionLogControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientActionLogDto>): ClientActionLogDto => r.body)
    );
  }

}
